import Box from "@mui/material/Box"

export default function TabContent({ value, index, children }) {
  return <>{value === index && children}</>
}

export function AlwaysPresentTabContent({ value, index, children }) {
  return (
    <Box sx={{ display: index === value ? "block" : "none" }}>{children}</Box>
  )
}
